import cx from 'clsx';
import React from 'react';
import { v4 as uuidv4 } from 'uuid';

import SkeletonBlock from '@components/common/Skeleton/SkeletonBlock';

import style from './style.module.scss';

const NewItemSkeleton = () => {
  return [...Array(10)].map(() => (
    <div key={uuidv4()} className={cx(style.whatsNewItemWrapper, style.skeletonWrapper)}>
      <div className={style.whatsNewItemBody}>
        <div className={style.whatsNewItemTitle}>
          <SkeletonBlock className={style.skeletonTextTitle} />
        </div>
        <div className={style.whatsNewItemDescription}>
          <SkeletonBlock className={style.skeletonTextDescription} />
        </div>
      </div>
      <div className={style.whatsNewItemFooter}>
        <SkeletonBlock className={style.skeletonTextFooter} />
      </div>
    </div>
  ));
};

export default NewItemSkeleton;
